var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('McProgressBar',{attrs:{"value":_vm.value,"min":_vm.min,"max":_vm.max,"label-position":_vm.labelPosition}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }